/**
 * Toma una cadena de texto que puede tener caracteres de escape de HTML (por
 * ejemplo &aacute;) y devuelve su correspondiente en texto plano.
 */
export const decodeHTMLEntities = (str: string) => {
  const parser = new DOMParser();
  const dom = parser.parseFromString(
    '<!doctype html><body>' + str,
    'text/html',
  );
  const decodedString = dom.body.textContent;
  return decodedString;
};
